/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgAperture = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm4.004 11.796L14.535 16h-.015l-2.796 3.995.027.001L12 20c2.5 0 4.733-1.147 6.2-2.944zM12.078 16l-7.007.001a8.023 8.023 0 0 0 4.477 3.616zm7.67-6h-3.88l.961 1.441 2.516 3.734A7.973 7.973 0 0 0 20 12a8 8 0 0 0-.252-2zM4.637 8.868A7.974 7.974 0 0 0 4 12c0 .69.088 1.361.252 2h3.879l-.956-1.434-.005-.009-.01-.014zM13.464 10h-2.929l-1.333 2 1.333 2h2.929l1.333-2zM12 4a7.985 7.985 0 0 0-6.231 2.982l2.219 3.233L9.465 8h.004l2.709-3.998zm2.355.352L11.884 8h7.046c-1-1.73-2.63-3.05-4.575-3.648z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgAperture as Aperture };
